import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { FormArray, FormGroup } from '@angular/forms';
import { ExternalLink } from './externalLink';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { swalMini } from '../../../../../../../shared/utils/utils';

const NODE_TYPE = 'externalLink';

@Component({
  selector: 'app-external-link',
  templateUrl: './external-link.component.html',
  styleUrls: ['./external-link.component.scss'],
})
export class ExternalLinkComponent extends NodeBuilder implements OnInit {

  externalLinkForm: FormGroup;
  logicForm: FormGroup;
  newStep = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    const externalLinkForms = ExternalLink.toForm(stepData, this.canEdit);
    this.externalLinkForm = externalLinkForms.ExternalLinkForm;
    this.logicForm = externalLinkForms.LogicForm;

    const results = this.logicForm.get('results') as FormArray;
    const defaultResult = results.at(0) as FormGroup;

    if (defaultResult.get('next').value === newStepValue) {
      this.newStep = 'step' + this.getNextStep();
      defaultResult.get('next').setValue(this.newStep);
    }
  }

  get getStepData(): {} {
    const formData = this.externalLinkForm.getRawValue();
    const logicData = this.logicForm?.getRawValue();

    const nodeData = new ExternalLink().nodeData;
    nodeData['menu']['text'] = formData.text;
    nodeData['menu']['url'] = formData.url;

    const results = {};

    logicData.results.forEach(resultGroup => {
      results[resultGroup.result] = {
        next: resultGroup.next,
        description: resultGroup.description,
      };
    });
    nodeData['menu']['results'] = results;

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.externalLinkForm.markAllAsTouched();
    this.logicForm.markAllAsTouched();
    return this.externalLinkForm.valid && this.logicForm.valid;
  }

  public addResult(): void {
    const results: FormArray = this.logicForm.get('results') as FormArray;

    const newResultGroup = ExternalLink.buildResultGroup('', '', newStepValue, this.canEdit.canEditFlows);

    results.push(newResultGroup);
  }

  public deleteResult(controlName: string, index: number): void {
    const resultsArray: FormArray = this.logicForm.get(controlName) as FormArray;
    if (resultsArray.length > 1) {
      resultsArray.removeAt(index);
    } else {
      swalMini({
        title: 'At least one option needed',
        type: 'error',
      });
    }
  }
}